// extracted by mini-css-extract-plugin
module.exports = {"feedback-tooltip-content":"RespondersTooltip-module__feedback-tooltip-content__2D7hj"};